import type { NextRoleSection } from 'src/components/Profile/NextRole/types';
import type { Card } from 'src/types';

import type { RetryAction, RetryActionStore } from './types';

export type RetryActionKey = Card | `next-role-${NextRoleSection}`;

type Action =
  | {
      type: 'setRetryAction';
      payload: { retryAction: RetryAction; key: RetryActionKey };
    }
  | {
      type: 'setCanRetry';
      payload: {
        canRetry: boolean;
        key: RetryActionKey;
      };
    }
  | {
      type: 'deleteRetryAction';
      payload: { key: RetryActionKey };
    };
export type Dispatch = (action: Action) => void;
export type State = RetryActionStore;

export const retryActionReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'setRetryAction': {
      const { retryAction, key } = action.payload;

      return { ...state, [key]: retryAction };
    }

    case 'deleteRetryAction': {
      const { key } = action.payload;
      const newState: State = {};

      Object.entries(state)
        .filter(([existingKey]) => existingKey !== key)
        .forEach(([existingKey, value]) => (newState[existingKey] = value));

      return newState;
    }

    case 'setCanRetry': {
      const { canRetry, key } = action.payload;

      if (key in state) {
        return { ...state, [key]: { action: state[key].action, canRetry } };
      }

      return state;
    }
  }
};
